<div class="space-y-6" [formGroup]="form()">
  <ci-property-search
    [selectedId]="selectedId()"
    [category]="category()"
    (picked)="applyInventory($event)"
  />

  <ui-meta-strip
    [ciLevel]="ciLevel()"
    [ciReference]="form().controls.ciReference.value"
  />

  <!-- Inventory-sourced identity, common to every flow -->
  <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
    <ui-readonly-field label="Property Name" [value]="form().controls.propertyName.value" />
    <ui-readonly-field label="Micro Market" [value]="form().controls.microMarket.value" />
    <ui-readonly-field label="Cluster" [value]="form().controls.cluster.value" />
  </div>

  @if (isLandLed()) {
    <!-- Plot / Independent House: area and price are typed -->
    <div class="grid gap-6 sm:grid-cols-2">
      <ui-manual-input
        [control]="form().controls.size"
        label="Plot Area (sq.ft)"
        type="number"
        placeholder="2400"
      />
      <ui-manual-input
        [control]="form().controls.quotedPrice"
        label="Current Asking Price (₹)"
        type="number"
        placeholder="41000000"
      />
    </div>
  } @else {
    <!-- Primary / Resale: taken from the selected property; any value the
         property record lacks can be typed so the step is never a dead end -->
    <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      @if (!missing().size) {
        <ui-readonly-field label="Size" [value]="sizeDisplay()" />
      } @else {
        <ui-manual-input [control]="form().controls.size" label="Size (sq.ft)" type="number" placeholder="1250" />
      }
      @if (!missing().price) {
        <ui-readonly-field label="Quoted Price of Unit" [value]="priceDisplay()" />
      } @else {
        <ui-manual-input [control]="form().controls.quotedPrice" label="Quoted Price of Unit (₹)" type="number" placeholder="16500000" />
      }
      @if (!missing().third) {
        <ui-readonly-field [label]="thirdFieldLabel()" [value]="thirdFieldValue()" />
      } @else {
        <ui-manual-input
          [control]="isPrimary() ? form().controls.configuration : form().controls.listingUnitName"
          [label]="thirdFieldLabel()"
          type="text"
        />
      }
    </div>

    <ui-calculated-box
      label="Quoted PSF"
      [value]="quotedPsf()"
      derivation="Quoted Price of Unit ÷ Size"
    />

    <ui-note-bar tone="info">{{ noteText() }}</ui-note-bar>
  }
</div>
